const answerPacks = state => state.answerPacks
const answers = state => index => state.answerPacks[index] ? state.answerPacks[index].answers : state.answerPacks[index]
const answerPacksSize = state => !state.answerPacks || !state.answerPacks[state.currentQuestion] ? 0 : state.answerPacks[state.currentQuestion].answers.length
const currentQuestion = state => state.currentQuestion
const error = state => state.error
const hasVoted = state => state.userVotes.length
const isLoading = state => state.loading
const questions = state => state.questions
const survey = state => state.survey
const surveyId = state => state.survey ? state.survey.id : undefined
const averageVotesCount = state => parseFloat(state.averageVotesCount)
const totalVotesCount = state => state.totalVotesCount
const userVotes = state => state.userVotes.length ? state.userVotes : undefined
const duration = state => state.duration
const rightAnswers = (state, getters) => {
  if (!getters.hasVoted) return undefined
  return state.answerPacks.map(answerPack => {
    const rightAnswers = answerPack.answers.filter(answer => answer.isRightAnswer)
    return rightAnswers.length > 0 ? rightAnswers[0].index : undefined
  })
}
const questionsTitles = state => {
  return state.questions.map(question => question.title)
}
const answerLists = (state) => state.answerPacks.map(answerPack => answerPack.answers)

export default {
  answerPacks,
  currentQuestion,
  error,
  hasVoted,
  isLoading,
  questions,
  survey,
  surveyId,
  answerPacksSize,
  averageVotesCount,
  totalVotesCount,
  answers,
  answerLists,
  rightAnswers,
  questionsTitles,
  userVotes,
  duration
}
